var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('footer',[_c('p',[_vm._v("版权所有Copyright © 浙江大学校医院")]),_c('a',{staticClass:"backstage",on:{"click":_vm.toBackstage}},[_vm._v("后台管理系统")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }